import { useConfirmDialog } from '@sl/react-datafabric-components';
import { useUnsubscribeMutation } from '../../../../common/redux/services/subscriptions';

export function useDeleteSubscriptionWithConfirmation() {
  const { hardConfirmation } = useConfirmDialog();
  const [unsubscribeMutation, { isLoading }] = useUnsubscribeMutation();

  const deleteSubscriptionWithConfirmation = (
    subscriptionData: any,
    {
      onSuccess,
      onError,
    }: // eslint-disable-next-line no-unused-vars
    { onSuccess: () => void; onError?: (error: any) => void }
  ) =>
    hardConfirmation({
      message: subscriptionData.trial
        ? 'Are you sure you want to remove the subscription? You will lose access immediately'
        : `Are you sure you want to remove the subscription? 
      You will lose access at the end of the cycle.`,
      hardConfirmationMessage: 'Please confirm by inserting your plan name: ',
      validateHardConfirmation: (input) =>
        input.toLowerCase() === subscriptionData.plan.name.toLowerCase(),
      accept() {
        unsubscribeMutation(subscriptionData.id)
          .unwrap()
          .then(() => {
            onSuccess();
          })
          .catch(onError);
      },
    });

  return {
    isLoading,
    deleteSubscriptionWithConfirmation,
  };
}
